import React, { FC, useState, useEffect } from "react";

import { Table, Row, Col, Button, message, Drawer, notification } from "antd";

import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";

import { RemovedTagModel, TagModel } from "states/tag/tag.models";
import { removeTag, getTagList } from "states/tag/tag.api";
import { t, CoreResource } from "shared/plugins/localization";
import { TagModalComponent } from "shared/components/tag/tag-modal";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchTagList, tagListSelector } from "states/tag/tag.slice";

interface ITagProps {}
const Tag: FC<ITagProps> = () => {
  const [selectedRowsKeys, setSelectedRowsKeys] = useState<RemovedTagModel>({
    idList: [],
  });
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [isModal, setModal] = useState(false);
  const [isUpdate, setUpdate] = useState(false);
  const [model, setModel] = useState<TagModel>({} as TagModel);
  const dispatch = useDispatch();
  const tagList = useSelector(tagListSelector, shallowEqual);
  const rowSelection = {
    selectedRowsKeys,
    onChange: (selectedRowKeys: any) => {
      setSelectedRowsKeys({ ...selectedRowsKeys, idList: selectedRowKeys });
    },
  };
  const onEmptySelection = () => {
    setSelectedRowsKeys({ ...selectedRowsKeys, idList: [] });
  };
  const handleCloseModal = () => {
    setModal(false);
  };
  const handleAddTag = () => {
    setModel({} as TagModel);
    setModal(true);
    setUpdate(false);
  };
  const onRefreshData = () => {
    dispatch(fetchTagList());
  };
  const onRemoveBtn = () => {
    const key = `open${Date.now()}`;
    const btn = (
      <Button
        type="primary"
        danger={true}
        onClick={async () => {
          try {
            await removeTag(selectedRowsKeys);
            notification.close(key);
            setSelectedRowsKeys({ ...selectedRowsKeys, idList: [] });
            onRefreshData();
            dispatch(fetchTagList());
            message.success({
              title: "Thành công",
              content: "Cập nhật thành công",
            });
          } catch (error) {
            message.error({
              title: "Thông báo",
              content:
                error?.response?.data?.error?.message ??
                "Lỗi hệ thống",
            });
          }
        }}
      >
        Xóa
      </Button>
    );
    notification.open({
      message: t(CoreResource, "QuestionRemove"),
      key,
      btn,
      placement: "bottomLeft",
    });
  };
  useEffect(() => {
    onRefreshData();
  }, []);
  const columns: ColumnsType<TagModel> = [
    {
      title: "Id",
      dataIndex: "id",
      key:"id",
      width:"40px",
      render: (id: string, item) => (
        <React.Fragment>
         {id}
        </React.Fragment>
      ),
    },
    {
      title: "Tên tag",
      dataIndex: "tagName",
      key: "tagName",
      render: (tagName: string, item) => (
        <React.Fragment>
          <Button
            type="text"
            onClick={() => {
              setModel(item);
              setModal(true);
              setUpdate(true);
            }}
          >
            {tagName}
          </Button>
        </React.Fragment>
      ),
    },
  ];
  return (
    <div className="Tag">
      <Row gutter={[16, 16]} justify="space-between" className="mb-4">
        <Col span={12}></Col>
        <Col span={12} className="d-flex justify-content-end">
          <Button
            type="primary"
            onClick={handleAddTag}
            icon={<PlusCircleOutlined />}
          >
           Thêm tag
          </Button>
        </Col>
      </Row>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        rowKey={(row) => row.id}
        dataSource={tagList}
        size="small"
        loading={isLoadingList}
      ></Table>
      <Drawer
        height="70px"
        mask={false}
        placement="bottom"
        closable={true}
        onClose={onEmptySelection}
        visible={
          selectedRowsKeys !== undefined &&
          selectedRowsKeys.idList !== undefined &&
          selectedRowsKeys.idList.length > 0
            ? true
            : false
        }
      >
        <Button
          type="primary"
          danger={true}
          onClick={onRemoveBtn}
          icon={<DeleteOutlined />}
        >
          Xóa ({selectedRowsKeys.idList.length}) dòng
        </Button>
      </Drawer>
      <TagModalComponent
        model={model}
        onModal={isModal}
        closeModal={handleCloseModal}
        onSuccess={onRefreshData}
        isUpdate={isUpdate}
      />
    </div>
  );
};

export default Tag;
